import { homeBrands } from "@/config/brands";
import { localizePath, useI18n } from "@/i18n";

export function BrandStrip() {
  const { t, locale } = useI18n();

  return (
    <section aria-labelledby="brands-strip-heading" className="border-b border-border bg-muted/40">
      <div className="container-page py-10 lg:py-12">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="eyebrow">{t.brands.eyebrow}</p>
            <h2 id="brands-strip-heading" className="display-3 mt-3 text-balance">
              {t.brands.title}
            </h2>
          </div>
          <a
            href={localizePath("/about", locale) + "#brands"}
            className="text-sm font-medium text-foreground underline-offset-4 hover:underline"
          >
            {t.brands.seeAll}
          </a>
        </div>

        {/* Text badges only — logoSrc reserved for future approved artwork. */}
        <ul className="mt-8 flex flex-wrap gap-3">
          {homeBrands.map((brand) => (
            <li key={brand.id}>
              <span className="inline-flex items-center rounded-md border border-border bg-card px-4 py-2 text-sm font-medium tracking-tight text-foreground">
                {brand.name}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
